import React from 'react';
import Typography from '@mui/material/Typography';

const FFLaborColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Name of Entity</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>List Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Entity Country</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Additional Remarks</Typography>
      </div>
    </>
  );
};

export default FFLaborColumns;
